import { route } from 'constant'

import { BreadcrumbItem } from 'components'

export const breadcrumbsData: BreadcrumbItem[] = [
  { url: route.customers, title: 'Customers' },
  { title: 'Customer Details' },
]
